module.exports = __webpack_public_path__ + "img/1.31d7ecb5.jpg";